module.exports = __webpack_public_path__ + "img/six.be5030ca.webp";